<template>
  <div>
    <search-bar></search-bar>
    <div class="clearfix">
      <div class="pull-right">
        <paginator />
      </div>
    </div>
    <b-table
      striped
      hover
      bordered
      show-empty
      fixed
      thead-class="table-primary"
      :items="items"
      :fields="fields"
      :busy="states.searching"
      class="mt-2"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{ $t("commons.loading") }}</strong>
        </div>
      </template>

      <template #cell(actions)="data">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="editJob(data)"
          class="mr-2 mb-2"
          v-if="permissions.job_edit"
        >
          Edit Job
        </b-button>
        <b-button id="show-btn"
          size="sm"
          variant="danger"
          @click="runJob(data)"
          class="mr-2 mb-2"
          v-if="permissions.job_run_now"
        >
          Run Job Now
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import JobsApi from "../../apis/JobsApi";

export default {
  name: 'JobIndex',
  props: {
    permissions: Object,
  },
  computed: {
    pagination() {
      return this.$store.state.searchStore.pagination;
    },
    items() {
      return this.$store.state.searchStore.items;
    },
    states() {
      return this.$store.state.searchStore.states;
    },
    searchName() {
      return this.$store.state.searchStore.simpleSearch.name;
    },
    searchId() {
      return this.$store.state.searchStore.simpleSearch.id;
    },
  },
  watch: {
    "states.searching": function (newVal, oldVal) {
      this.getJobs();
    },
    searchName: function (newVal) {
      this.getJobs();
    },
    searchId: function (newVal) {
      this.getJobs();
    },
    "states.hasCleared": function (newVal, oldVal) {
      this.getJobs();
    }
  },
  data() {
    return {
      fields: ["id", "name", "command", "cron_schedule", "last_run_time", "actions"],
      searchCriteria: {},
      view: false
    };
  },
  created() {
    this.$store.commit("searchStore/updateStates", {
      searching: true,
    });
  },
  methods: {
    editJob(row) {
      window.location.href = `/jobs/edit/${row.item.id}`;
    },
    addJob() {
      window.location.href = `/jobs/add`;
    },
    runJob(row) {
      window.location.href = `/jobs/run/${row.item.id}`;
    },
    getJobs() {
      const self = this;

      let filters = {};

      filters["name"] = this.searchName;
      filters["id"] = this.searchId;

      this.errorMessage = this.successMessage = null;

      this.$store.commit("searchStore/updateStates", {
        hasError: false,
      });

      const params = {
        filters: filters,
        limit: this.pagination.limit,
        offset: (this.pagination.page - 1) * this.pagination.limit,
      };

      JobsApi.all(params)
        .then((response) => {
          this.$store.commit("searchStore/setItems", response);
          this.$store.commit("searchStore/updateStates", {
            searching: false,
          });
        })
        .catch((e) => {
          this.$store.commit("searchStore/updateStates", {
            searching: false,
            hasError: true,
          });
          if (e.response && e.response.status == 400) {
            this.errorMessage = e.response.data.data.detail;
          }
          this.$toast.error("Error", this.errorMessage);
        });
    }
  }
}
</script>
